import type { TabDefinition } from '../types/customers';

export const BLACKLIST_PHONE_EDIT = [
  '+12487588857',
  '+12483026074',
  '+14245885130',
];
export const ACCEPTED_FILE_TYPES = ['image/*', 'application/pdf'];

export const TAB_DEFINITIONS: readonly TabDefinition[] = [
  { id: 'timeline', label: 'Timeline' },
  { id: 'appointments', label: 'Appointments' },
  { id: 'payments', label: 'Payments' },
  { id: 'forms-files', label: 'Forms & files' },
];
// Small screens fold the profile overview into the tab strip.
export const PROFILE_TAB: TabDefinition = { id: 'profile', label: 'Profile' };

export const RAIL_NODE_WIDTH = 32;
export const RAIL_COLUMN_GAP = 20;
